<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        Legal
      </content-page-title>
    </template>

    <v-list class="py-0 rounded-lg">
      <MenuItem title="Terms of Service" :to="{ name: 'you/legal/tos' }"/>

      <v-divider/>

      <MenuItem title="Privacy Policy" :to="{ name: 'you/legal/privacy' }"/>

      <v-divider/>

      <MenuItem title="Disputed Lead Policy" :to="{ name: 'you/legal/dispute' }"/>
    </v-list>
  </ContentPage>
</template>

<script>

import { ContentPage, ContentPageTitle, MenuItem } from '@/components/pages'

export default {
  components: { ContentPage, ContentPageTitle, MenuItem },
}
</script>